
import { useRef } from "react";
import { GraphData } from "./useGraphData";
import { useZoomControls } from "./hooks/useZoomControls";
import { useCenterView } from "./hooks/useCenterView";
import { useGraphInitialization } from "./hooks/useGraphInitialization";
import { useForceEngineOptions } from "./hooks/useForceEngineOptions";
import { useNodeRenderConfig } from "./hooks/useNodeRenderConfig";

export const useGraphBehavior = (isGraphReady: boolean) => {
  const graphRef = useRef<any>(null);
  const nodeConfig = useNodeRenderConfig();
  
  const { centerView, handleCenterView, drawBoundingBox } = useCenterView({ graphRef });
  
  const { handleZoomIn, handleZoomOut, applyInitialZoom } = useZoomControls({ 
    graphRef, 
    INITIAL_ZOOM_FACTOR: nodeConfig.INITIAL_ZOOM_FACTOR 
  });
  
  const { pendingDataChange, initializeGraphRender } = useGraphInitialization({
    graphRef,
    isGraphReady,
    centerView,
    applyInitialZoom
  });
  
  const forceEngineOptions = useForceEngineOptions();

  // Create a function to handle centerView that includes zoom
  const handleCenterViewWithZoom = (graphData: GraphData) => {
    handleCenterView(graphData, applyInitialZoom);
  };

  return {
    graphRef,
    pendingDataChange,
    drawBoundingBox,
    centerView,
    applyInitialZoom,
    handleZoomIn,
    handleZoomOut,
    handleCenterView: handleCenterViewWithZoom,
    initializeGraphRender,
    forceEngineOptions,
    ...nodeConfig
  };
};
